export default "__VITE_ASSET__ba9a9721__"